import React, { useEffect, useRef } from "react";

/**
 * Mouse-following soft gold radial glow, scoped to the parent (e.g. Hero).
 * Pointer events disabled. Disabled on touch devices.
 */
export const MouseGlow = ({ size = 520, color = "rgba(212,175,55,0.18)" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const isTouch =
      typeof window !== "undefined" &&
      window.matchMedia("(pointer: coarse)").matches;
    if (isTouch) return;

    const el = ref.current;
    if (!el) return;
    const parent = el.parentElement;
    if (!parent) return;

    let raf;
    let tx = 0, ty = 0, cx = 0, cy = 0;
    const onMove = (e) => {
      const rect = parent.getBoundingClientRect();
      tx = e.clientX - rect.left;
      ty = e.clientY - rect.top;
    };
    const tick = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      el.style.transform = `translate3d(${cx - size / 2}px, ${cy - size / 2}px, 0)`;
      raf = requestAnimationFrame(tick);
    };
    parent.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      parent.removeEventListener("mousemove", onMove);
    };
  }, [size]);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="absolute top-0 left-0 pointer-events-none transition-opacity duration-500 hidden md:block"
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle, ${color} 0%, rgba(212,175,55,0.04) 40%, transparent 70%)`,
        filter: "blur(20px)",
        willChange: "transform",
      }}
    />
  );
};
